import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Contacts commerciaux JS en cours ...");
        super.connect();
        console.log("current app: " + this.current_app)
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            //this.show_edition_multiple();
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
        }

        // missions
        if (
            $("#partial-mission-content").length &&
            $("#partial-mission-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.contacts_commerciaux_hm_ajax_missions(), 300);
        }

        // campagne_destinataires
        if (
            $("#partial-campagne-destinataires-content").length &&
            $("#partial-campagne-destinataires-content").text().trim() === "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.contacts_commerciaux_hm_ajax_campagne_destinataires(), 300);
        }
    }

    // missions
    contacts_commerciaux_hm_ajax_missions() {
        if (this.current_app && this.contacts_commerciaux_id) {
            let item = "#partial-mission-content"
            let innerText = "Chargement en cours ..."
            if ($(item).length &&
                $(item).text().trim() === innerText
            ) {
                let url =
                    window.location.origin +
                    "/" +
                    this.current_app +
                    "/contacts_commerciauxes/show_ajax_for_hm_missions?contacts_commerciaux_id=" +
                    this.contacts_commerciaux_id +
                    "&vr2=1";
                fetch(url).then((response) =>
                    response.text().then(function (text) {
                        $(item).html("");
                        $(item).html(text);
                    })
                );
            } else {
                console.error("Elem by id not found: '" + item + "' and/or inner not equals '" + innerText + "'")
            }
        } else {
            console.error("Current app value and/or 'contacts_commerciaux_id' is/are missing !")
        }
    }

    contacts_commerciaux_hm_ajax_campagne_destinataires() {
        if (this.current_app && this.contacts_commerciaux_id) {
            let item = "#partial-campagne-destinataires-content"
            let innerText = "Chargement en cours ..."
            if ($(item).length &&
                $(item).text().trim() === innerText
            ) {
                let url =
                    window.location.origin +
                    "/" +
                    this.current_app +
                    "/contacts_commerciauxes/show_ajax_for_hm_campagne_destinataires?contacts_commerciaux_id=" +
                    this.contacts_commerciaux_id +
                    "&vr2=1";
                fetch(url).then((response) =>
                    response.text().then(function (text) {
                        $(item).html("");
                        $(item).html(text);
                    })
                );
            } else {
                console.error("Elem by id not found: '" + item + "' and/or inner not equals '" + innerText + "'")
            }
        } else {
            console.error("Current app value and/or 'contacts_commerciaux_id' is/are missing !")
        }
    }

    show_edition_multiple() {
        console.log(this.current_app, this.params)
        console.log(this.current_app && this.params)
        if (this.current_app) {
            console.log('multiple edition')
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/contacts_commerciauxes/show_ajax_multiple_edition?" +
                this.params +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#multiple_edition").html("");
                    $("#multiple_edition").html(text);
                    MicroModal.init()
                })
            );
        }
    }

    get params() {
        return this.data.get("params");
    }

    get contacts_commerciaux_ids() {
        return this.data.get("contacts_commerciaux_ids");
    }

    get contacts_commerciaux_id() {
        return this.data.get("contacts_commerciaux_id");
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("url-solution");
    }

}
